import React, { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

import DashboardV2 from "../dashboard_v2/DashboardV2";
import { API_BASE_URL } from "../config/apiBase";
import { getAuthUserHeader } from "../utils/userRoles";

const API = API_BASE_URL;

function buildLessonKey(week, lesson) {
  const weekNum = Number(week);
  const lessonNum = Number(lesson);
  if (!weekNum || !lessonNum) return "";
  return `W${weekNum}L${lessonNum}`;
}

export default function TutorStudentList() {
  const { studentId, weekId, lessonId } = useParams();
  const location = useLocation();

  const initialSelectedLessonKey = useMemo(
    () => buildLessonKey(location.state?.selectedWeek || weekId, location.state?.selectedLesson || lessonId),
    [lessonId, location.state, weekId]
  );
  const dashboardHeaders = useMemo(() => ({ "X-User": getAuthUserHeader() }), []);

  return (
    <DashboardV2
      dashboardEndpoint={`${API}/api/tutor/student/${studentId}/dashboard_v2`}
      dashboardHeaders={dashboardHeaders}
      disableStandaloneNav
      initialSelectedLessonKey={initialSelectedLessonKey}
    />
  );
}
